export default class PaWorkLvMoneyController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWorkLvMoney/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWorkLvMoney/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paWorkLvMoney/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWorkLvMoney/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWorkLvMoney/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWorkLvMoney/delete', 'post', params, axiosOption, httpOption);
  }
}
